import RenewalAnalyticsView from "../../features/MetabaseDashboard/RenewalAnalyticsView"

const RenewalAnalyticsReport = () => {
  return (
    <div><RenewalAnalyticsView /></div>
  )
}

export default RenewalAnalyticsReport